export const platforms = [
  'Web',
  'Mobile Responsive',
  'Native Mobile App',
  'Hybrid Mobile App',
  'API',
  'Database Testing',
  'ETL',
  'ML Algorithms',
  'Kiosk',
];

export const subPlatformOptions = [
  { id: 'windows', name: 'Windows', category: 'Web' },
  { id: 'mac', name: 'Mac', category: 'Web' },
  { id: 'ios', name: 'iOS', category: 'Mobile' },
  { id: 'android', name: 'Android', category: 'Mobile' },
];

export const platformToCategoryMap = {
  Web: 'Web',
  'Mobile Responsive': 'Mobile',
  'Native Mobile App': 'Mobile',
  'Hybrid Mobile App': 'Mobile',
};

export const browserOptions = [
  'Chrome',
  'Firefox',
  'Edge',
  'Safari',
  'Opera',
  'Others',
];

export const cloudDeviceLabs = [
  'AWS Device Farm',
  'Browserstack',
  'Internal',
  'Lambdatest',
  'SauceLabs',
  'Others',
];

export const selectStyle = {
  fontSize: '14px',
  maxHeight: '48px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ced4da',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ced4da',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ced4da',
  },
};
